const PROJECT_TABS = {
  TASKS: 'tasks',
  TASK: 'task',
  NOTES: 'notes',
  REPOSITORY: 'repositories',
};

export default PROJECT_TABS;
